<template>
  <div class="document-upload-component">
    <a-button type="primary" @click="showModal">Bestanden uploaden</a-button>
    <a-modal title="Documenten uploaden" :closable="false" :visible="displayModal" width="60%"
             class="document-upload-modal">
      <p><b>Selecteer een klant:</b></p>
      <a-tabs default-active-key="family" :tab-bar-style="{height:40}" size="small">
        <a-tab-pane key="family" tab="Familie">
          <CustomerSelectFamilyMemberComponent ref="customerSelectFamilyMember" :customer-id="customerId"
                                               v-on:customer-selected="onCustomerSelected"></CustomerSelectFamilyMemberComponent>
        </a-tab-pane>
        <a-tab-pane key="all" tab="Alle klanten">
          <CustomerSearchByNameComponent ref="customerSearchByName" :clear-results-after-selection="false"
                                         v-on:customer-selected="onCustomerSelected"></CustomerSearchByNameComponent>
        </a-tab-pane>
      </a-tabs>

      <div v-if="hasSelectedCustomer" style="margin-top: 15px;">
        <p><b>Selecteer een hoofdcategorie:</b></p>
        <CategorySelectMainCategoryComponent :key="selectedCustomer.id"
                                             v-on:category-selected="onCategorySelected"></CategorySelectMainCategoryComponent>

        <div v-if="hasSelectedCategory" style="margin-top: 15px;">
          <p><b>Selecteer een map:</b></p>
          <AttachableCategorySelectByCustomerAndCategoryComponent
              :key="selectedCustomer.id + '-' + selectedCategory"
              :customer="selectedCustomer" :category="selectedCategory"
              v-on:category-selected="onAttachableCategorySelected">
          </AttachableCategorySelectByCustomerAndCategoryComponent>

          <div v-if="hasSelectedAttachableCategory" style="margin-top: 15px;">
            <DocumentUploadComponent :key="selectedAttachableCategory.id"
                                     :attachable-category-id="selectedAttachableCategory.id"
                                     :customer-id="selectedCustomer.id"
                                     @successful-document-upload="successfulDocumentUpload"/>
          </div>
        </div>
      </div>
      <template slot="footer">
        <a-button key="back" @click="closeModal" type="default">
          Sluiten
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import DocumentUploadComponent from "~/modules/document/components/DocumentUploadComponent"
import CustomerSelectFamilyMemberComponent from "../../customer/components/SelectFamilyMemberComponent";
import CustomerSearchByNameComponent from "../../customer/components/SearchByNameComponent";
import CategorySelectMainCategoryComponent from "../../category/components/SelectMainCategoryComponent";
import AttachableCategorySelectByCustomerAndCategoryComponent
  from "../../attachable_category/components/SelectByCustomerAndCategoryComponent";

export default {
  name: "CustomerAttachableUploadComponent",
  components: {
    AttachableCategorySelectByCustomerAndCategoryComponent,
    CategorySelectMainCategoryComponent,
    CustomerSearchByNameComponent,
    CustomerSelectFamilyMemberComponent,
    DocumentUploadComponent
  },
  props: {
    customerId: {
      required: true,
      type: [Number, String]
    }
  },
  data() {
    return {
      displayModal: false,
      selectedCustomer: null,
      selectedCategory: null,
      selectedAttachableCategory: null,
      hasSuccessfulDocumentUpload: false,
    }
  },
  computed: {
    hasSelectedCustomer() {
      return this.selectedCustomer !== null;
    },
    hasSelectedCategory() {
      return this.selectedCategory !== null;
    },
    hasSelectedAttachableCategory() {
      return this.selectedAttachableCategory !== null;
    },
  },
  methods: {
    successfulDocumentUpload() {
      this.hasSuccessfulDocumentUpload = true;
    },
    showModal() {
      this.displayModal = true;
    },
    closeModal() {
      this.selectedCustomer = null;
      this.selectedCategory = null;
      this.selectedAttachableCategory = null;
      this.displayModal = false;

      if (this.hasSuccessfulDocumentUpload) {
        // this.$message.success('Een moment geduld a.u.b. de pagina word opnieuw geladen zodra de documenten zijn verwerkt.');
        this.$notification['success']({
          message: 'De pagina word opnieuw geladen',
          description:
              'De documenten worden verwerkt, een moment geduld a.u.b.',
        });
        location.reload();
      }
    },
    onCustomerSelected(customer) {
      this.selectedCustomer = customer;
      this.selectedCategory = null;
      this.selectedAttachableCategory = null;
      this.updateSelectedCustomer(customer);
    },
    updateSelectedCustomer(customer) {
      if (typeof this.$refs.customerSelectFamilyMember !== "undefined") {
        this.$refs.customerSelectFamilyMember.selectedCustomer = customer;
      }
      if (typeof this.$refs.customerSearchByName !== "undefined") {
        this.$refs.customerSearchByName.selectedCustomer = customer;
      }
    },
    onCategorySelected(category) {
      this.selectedCategory = category;
      this.selectedAttachableCategory = null;
    },
    onAttachableCategorySelected(attachableCategory) {
      this.selectedAttachableCategory = attachableCategory;
    },
  }
}
</script>
<style scoped>

</style>